import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { FilteredBlocks } from '../../ui-kit/BaseFiltration/FilteredBlocks.js';
import { FiltrationForm } from '../../ui-kit/BaseFiltration/FiltrationForm.js';
import { useFiltrationForm } from '../../ui-kit/BaseFiltration/useFiltrationForm.js';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { Button } from '../../ui-kit/Button/Button.js';
import { Select } from '../../ui-kit/Select/Select.js';
import { UniBlock } from '../../UniBlock/UniBlock.js';
import { zip } from '../../utils/fp/zip.js';
import { style } from '../../utils/style.js';
const EMPTY_SCHEMA = {};
const initialFiltrationState = {};
export const BankAccountFiltration = UniBlock(({ className, filtrationSchema = EMPTY_SCHEMA, consumerField = {}, resetButton, ...rest }) => {
    const [, { blocksToRender }, { field, reset }] = useFiltrationForm(initialFiltrationState, {
        block: rest.block,
        page: rest.options?.page,
    });
    const ConsumerSelect = (_jsx(Select, { className: "w-64", label: consumerField?.title, options: stringArrayToOptions(consumerField), ...field('consumer', {
            parse: ({ key }) => [key],
            format: ([value] = []) => stringArrayToOptions(consumerField).find((_) => _.key === value) || { key: '' },
        }) }));
    return (_jsxs(BlockWrapper, { className: style(className), defaultPadding: "p-0", version: "transparent", ...rest, children: [_jsx(FiltrationForm, { filtrationSchema: filtrationSchema, field: field, reset: reset, children: _jsxs("div", { children: [ConsumerSelect, _jsx("div", { children: _jsx(Button, { type: "reset", className: "mt-lg w-64", onClick: reset, version: resetButton?.version, children: resetButton?.text }) })] }) }), _jsx(FilteredBlocks, { blocksToRender: blocksToRender, ...rest })] }));
}, {
    childrenTypes: ['CarouselTariffsCard'],
    childSchema: (content) => ({
        ...content?.filtrationSchema,
        ...(content?.consumerField ? { consumer: content?.consumerField } : {}),
    }),
});
const stringArrayToOptions = (stringEnum) => zip(stringEnum.items?.enum || [], stringEnum.items?.enumNames || []).map(([key, text]) => ({
    key,
    text,
}));
//# sourceMappingURL=BankAccountFiltration.js.map